const stateCheckin = {
    nameComponent: 'Store Checkin state Global',
    count_checkin: 0,
}

export default stateCheckin;